<template>
  <v-app>
    <alert-container :alerts="alerts" />
    <pages-core-app-bar />

    <pages-core-view />

    <pages-core-footer />
  </v-app>
</template>

<script>
import AlertContainer from '@/components/custom/AlertContainer.vue'
import { alertsSymbol } from '@/shared/state-management/symbols'
import { defineComponent, inject } from '@vue/composition-api'
export default defineComponent({
  name: 'PagesIndex',

  components: {
    PagesCoreAppBar: () => import('./components/core/AppBar'),
    PagesCoreFooter: () => import('./components/core/Footer'),
    PagesCoreView: () => import('./components/core/View'),
    AlertContainer,
  },
  setup() {
    const alerts = inject(alertsSymbol)
    return { alerts }
  },
  created() {
    this.$vuetify.theme.dark = false
  },

  beforeDestroy() {
    this.$vuetify.theme.dark = false
  },
})
</script>
